import { Breakpoint } from '@/enums'
import { theme } from '@/theme'

declare global {
  interface Window {
    HubSpotConversations?: {
      widget?: {
        status?: () => { loaded: boolean }
        load?: () => void
        open?: () => void
      }
    }
  }
}

export const isHubspotChatLoaded = (): boolean =>
  !!window.HubSpotConversations?.widget?.status?.().loaded

export const loadDesktopHubspotChat = (): void => {
  const load = window.HubSpotConversations?.widget?.load
  const shouldLoad =
    window.innerWidth > theme.breakpoints.values[Breakpoint.tab]

  if (load && shouldLoad) {
    load()
  }
}

export const openHubspotChat = (): void => {
  if (isHubspotChatLoaded()) {
    window.HubSpotConversations?.widget?.open?.()
  }
}
